import { useEffect } from 'react';
const CustomExternalRedirect = ({ to }) => {
    useEffect(() => {
      window.location.href = to;
    }, []);
    return null;
};
  
export default CustomExternalRedirect;